import * as Scrivito from "scrivito";

function LinkWrapper({ link, children, className = "" }) {
  if (!link || Scrivito.isInPlaceEditingActive()) {
    return children;
  }
  return (
    <Scrivito.LinkTag to={link} title={link.title()} className={className}>
      {children}
    </Scrivito.LinkTag>
  );
}

export default Scrivito.connect(LinkWrapper);
